import { disableButtonsByClass, enableButtonsByClass, addQueryParam } from "./utils.js";
import { markSwanbotUrlCalled, syncSwanbotUrlState } from "./state.js";
import { consumeDataExplorerReleasedSession, monitorRequestAndPoll, renderDataExplorerStatus, resetDataExplorerKeepAliveCounter, setDataExplorerSwanbotSession, trackDataExplorerSwanbotRequest } from "./polling.js";
import { setDataExplorerGraphDataPendingBadge } from "./dataexplorer_tabs.js";
import { preserveApproximationTildes } from "./markdown_utils.mjs";
import { isSwanbotRelayEnabled, streamDataExplorerChat } from "./swanbot_relay.js";
import { buildAgentRequestUrl } from "./agent_requests.mjs";

export let swanbot_dataexplorer_admin_clickhandler = function (event) { event.preventDefault(); };
export let swanbot_dataexplorer_datepicker_null_clickhandler = function (event) { event.preventDefault(); };
import { swanbot_URL } from "./api.js";

import { getShortTimezone } from "./calendar.js";

/* Swanbot UI logic extracted from legacy_events.js */

let dataExplorerSessionExpiryNotifiedForSession = null;
let graphDataRequestInFlight = false;
let graphDataPendingRequestArgs = null;
let graphDataPendingPromise = null;
let graphDataPendingPromiseResolve = null;
let graphDataPendingPromiseReject = null;
let lastResolvedDataExplorerWindow = null;
const SWANBOT_CAPACITY_RETRY_DELAY_MS = 10000;
let dataExplorerRelayAbortController = null;

function getRetryAfterHeader(error) {
	const headers = error.response && error.response.headers;
	return headers && typeof headers.get === 'function'
		? headers.get('retry-after')
		: headers && headers['retry-after'];
}

function isSwanbotCapacityUnavailable(error) {
	if (!error || !error.response || error.response.status !== 503) {
		return false;
	}

	const responseData = error.response.data;
	const hasCapacityCode = responseData && responseData.code === 'pool_capacity_unavailable';
	const hasEmptyBody = responseData === undefined || responseData === null || responseData === '';
	return hasCapacityCode || (hasEmptyBody && getRetryAfterHeader(error) != null);
}

function showSwanbotCapacityWait() {
	const chatoutput = document.getElementById('dataexplorer-data-results');
	if (!chatoutput) {
		return function () {};
	}

	const message = document.createElement('div');
	message.className = 'chat-message other swanbot-capacity-wait';
	message.setAttribute('role', 'status');
	message.setAttribute('aria-live', 'polite');

	const statusRow = document.createElement('div');
	statusRow.className = 'swanbot-capacity-status';

	const status = document.createElement('span');
	status.textContent = 'No swans in the lake. Checking all the ponds. ';
	statusRow.appendChild(status);

	const pond = document.createElement('span');
	pond.className = 'swanbot-capacity-pond';
	pond.setAttribute('aria-hidden', 'true');
	const leftBank = document.createElement('span');
	leftBank.className = 'swanbot-capacity-bank swanbot-capacity-bank-left';
	leftBank.textContent = '(';
	pond.appendChild(leftBank);
	const visitor = document.createElement('span');
	visitor.className = 'swanbot-capacity-visitor';
	pond.appendChild(visitor);
	const rightBank = document.createElement('span');
	rightBank.className = 'swanbot-capacity-bank swanbot-capacity-bank-right';
	rightBank.textContent = ')';
	pond.appendChild(rightBank);
	statusRow.appendChild(pond);
	message.appendChild(statusRow);

	const waitText = document.createElement('span');
	waitText.className = 'swanbot-capacity-wait-text';
	waitText.textContent = 'PLEASE WAIT';
	message.appendChild(waitText);
	const swanbotLoading = document.getElementById('swanbot_loading');
	if (swanbotLoading && swanbotLoading.parentElement === chatoutput) {
		chatoutput.insertBefore(message, swanbotLoading);
	} else {
		chatoutput.appendChild(message);
	}
	message.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });

	const pondVisitors = [
		{ emoji: '🐟', bankOnly: false },
		{ emoji: '🦆', bankOnly: true },
		{ emoji: '🐸', bankOnly: true },
		{ emoji: '🐢', bankOnly: false },
		{ emoji: '🦢', bankOnly: false }
	];
	let pondVisitorIndex = Math.floor(Math.random() * pondVisitors.length);
	let visitorHideTimeout = null;
	const revealPondVisitor = function () {
		const pondVisitor = pondVisitors[pondVisitorIndex];
		visitor.textContent = pondVisitor.emoji;
		visitor.classList.remove('at-left-bank', 'at-right-bank');
		visitor.style.left = '';
		visitor.style.right = '';
		if (pondVisitor.bankOnly) {
			visitor.classList.add(Math.random() < 0.5 ? 'at-left-bank' : 'at-right-bank');
		} else {
			visitor.style.left = (20 + Math.random() * 60).toFixed(1) + '%';
		}
		pondVisitorIndex = (pondVisitorIndex + 1) % pondVisitors.length;
		visitor.classList.add('is-visible');
		visitorHideTimeout = window.setTimeout(function () {
			visitor.classList.remove('is-visible');
		}, 2200);
	};
	const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	let visitorRevealTimeout = null;
	let visitorInterval = null;
	if (prefersReducedMotion) {
		visitor.textContent = pondVisitors[0].emoji;
		visitor.classList.add('is-visible');
	} else {
		visitorRevealTimeout = window.setTimeout(revealPondVisitor, 2200);
		visitorInterval = window.setInterval(revealPondVisitor, 6000);
	}

	return function () {
		window.clearTimeout(visitorRevealTimeout);
		window.clearTimeout(visitorHideTimeout);
		window.clearInterval(visitorInterval);
		message.remove();
	};
}

function resolveDataExplorerPeriodType() {
	let periodSwitchEl = document.getElementById('idp-period-switch');
	if (periodSwitchEl) {
		return periodSwitchEl.checked ? 'daily' : 'hourly';
	}

	let dataexplorerDailyOnlyInput = document.getElementById('dataexplorer_daily_only');
	let isDailyOnlyLocked = (
		window.swanbot_dataexplorer_lock_period_selection === true ||
		(dataexplorerDailyOnlyInput && String(dataexplorerDailyOnlyInput.value).toLowerCase() === 'true')
	);

	if (isDailyOnlyLocked || window.swanbot_dataexplorer_filter_period === 'day') {
		return 'daily';
	}

	return 'hourly';
}

function readDataExplorerLatestAvailableUtc() {
	let maxDateStr = '';
	try {
		let activeCustomerId = 'global';
		let customerInput = document.getElementById('customer_id');
		if (customerInput && customerInput.value) {
			activeCustomerId = String(customerInput.value).trim();
		}

		let latestAvailableUtcEl = document.getElementById('dataexplorer_latest_available_utc');
		if (latestAvailableUtcEl) {
			let latestAvailableUtcValue = String(latestAvailableUtcEl.textContent || '').trim();
			if (latestAvailableUtcValue) {
				maxDateStr = latestAvailableUtcValue;
			}
		}

		if (window.sessionStorage && window.moment && window.moment.utc) {
			let storedMax = window.sessionStorage.getItem('dataexplorer_max_available_utc_v1:' + activeCustomerId);
			if (storedMax) {
				let storedTs = window.moment.utc(storedMax).valueOf();
				let backendTs = maxDateStr ? window.moment.utc(maxDateStr).valueOf() : 0;
				if (!maxDateStr || storedTs > backendTs) {
					maxDateStr = storedMax;
				}
			}
		}
	} catch (e) {
		console.log('Error checking latest available UTC:', e);
	}

	return maxDateStr;
}

function renderDataExplorerLatestGapNote(latestAvailableUtcText, pinnedEndUtcText) {
	if (typeof window.renderDataExplorerLatestAvailableLabels === 'function') {
		window.renderDataExplorerLatestAvailableLabels(latestAvailableUtcText);
	}

	let container = document.getElementById('dataexplorer_latest_available_jsfe');
	if (!container) {
		return;
	}

	if (!window.moment || !window.moment.utc || !latestAvailableUtcText || !pinnedEndUtcText) {
		return;
	}

	let latestUtc = window.moment.utc(latestAvailableUtcText, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
	if (!latestUtc.isValid()) {
		latestUtc = window.moment.utc(latestAvailableUtcText);
	}

	let selectedEndUtc = window.moment.utc(pinnedEndUtcText, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
	if (!selectedEndUtc.isValid()) {
		selectedEndUtc = window.moment.utc(pinnedEndUtcText);
	}

	if (!latestUtc.isValid() || !selectedEndUtc.isValid()) {
		return;
	}

	let latestLabelText = String(container.textContent || '').trim();

	let deltaMinutes = Math.floor((latestUtc.valueOf() - selectedEndUtc.valueOf()) / 60000);
	let absMinutes = Math.abs(deltaMinutes);
	let hours = Math.floor(absMinutes / 60);
	let minutes = absMinutes % 60;
	let durationText;
	if (hours > 0 && minutes > 0) {
		durationText = String(hours) + 'h ' + String(minutes) + 'm';
	} else if (hours > 0) {
		durationText = String(hours) + 'h';
	} else {
		durationText = String(minutes) + 'm';
	}

	let isExactMatch = latestUtc.valueOf() === selectedEndUtc.valueOf();
	let noteText;
	if (deltaMinutes > 0) {
		noteText = 'Latest available is ' + durationText + ' ahead of your selected end time.';
	} else if (deltaMinutes < 0) {
		noteText = 'Latest available is ' + durationText + ' behind your selected end time.';
	} else {
		noteText = 'Latest available matches your selected end time.';
	}

	let statusIconHtml = isExactMatch
		? '<span aria-hidden="true" style="margin-left:6px;">✅</span>'
		: '<span aria-hidden="true" style="color:#ffc107;margin-left:6px;">&#9888;</span>';
	container.innerHTML = '<span>' + latestLabelText + '</span>' + statusIconHtml;

	let noteEl = document.getElementById('dataexplorer_latest_available_gap_note_jsfe');
	if (!noteEl) {
		noteEl = document.createElement('div');
		noteEl.id = 'dataexplorer_latest_available_gap_note_jsfe';
		noteEl.style.fontSize = '11px';
		noteEl.style.color = 'rgb(119, 119, 119)';
		noteEl.style.marginTop = '2px';
		container.appendChild(noteEl);
	}

	if (isExactMatch) {
		noteEl.style.display = 'none';
		noteEl.textContent = '';
	} else {
		noteEl.style.display = 'block';
		noteEl.textContent = noteText;
	}
}

function getQueuedGraphDataRequestPromise() {
	if (!graphDataPendingPromise) {
		graphDataPendingPromise = new Promise(function (resolve, reject) {
			graphDataPendingPromiseResolve = resolve;
			graphDataPendingPromiseReject = reject;
		});
	}

	return graphDataPendingPromise;
}

function clearQueuedGraphDataRequestPromise() {
	graphDataPendingPromise = null;
	graphDataPendingPromiseResolve = null;
	graphDataPendingPromiseReject = null;
}

function resolveQueuedGraphDataRequestPromise(value) {
	if (graphDataPendingPromiseResolve) {
		graphDataPendingPromiseResolve(value);
	}

	clearQueuedGraphDataRequestPromise();
}

function rejectQueuedGraphDataRequestPromise(error) {
	if (graphDataPendingPromiseReject) {
		graphDataPendingPromiseReject(error);
	}

	clearQueuedGraphDataRequestPromise();
}

async function replayQueuedGraphDataRequest() {
	const nextRequestArgs = graphDataPendingRequestArgs;

	if (!nextRequestArgs) {
		return;
	}

	graphDataPendingRequestArgs = null;
	setDataExplorerGraphDataPendingBadge(false);

	try {
		const replayResult = await load_explorer_swanbot(nextRequestArgs.context, nextRequestArgs.query, nextRequestArgs.modality);

		if (typeof window.fade_dataexplorer_graph === 'function') {
			await window.fade_dataexplorer_graph();
		}

		if (window.make_dataexplorer_graph) {
			await window.make_dataexplorer_graph();
		}

		resolveQueuedGraphDataRequestPromise(replayResult);
	} catch (error) {
		rejectQueuedGraphDataRequestPromise(error);
	}
}

function drawDataExplorerSessionExpiredDivider() {
	const chatoutput = document.getElementById("dataexplorer-data-results");

	if (!chatoutput) {
		return;
	}

	const divider = document.createElement('div');
	divider.setAttribute('data-session-expired', 'true');
	divider.style.position = 'relative';
	divider.style.margin = '18px 0';
	divider.style.textAlign = 'center';

	const line = document.createElement('div');
	line.style.borderTop = '2px solid #dc3545';
	line.style.width = '100%';
	line.style.position = 'absolute';
	line.style.top = '50%';
	line.style.left = '0';
	line.style.transform = 'translateY(-50%)';

	const label = document.createElement('span');
	label.textContent = 'SESSION EXPIRED/CHANGED';
	label.style.position = 'relative';
	label.style.display = 'inline-block';
	label.style.padding = '0 10px';
	label.style.backgroundColor = '#ffffff';
	label.style.color = '#000000';
	label.style.fontSize = '10px';
	label.style.fontWeight = '700';
	label.style.letterSpacing = '0.08em';
	label.style.textTransform = 'uppercase';

	divider.appendChild(line);
	divider.appendChild(label);
	chatoutput.appendChild(divider);
	divider.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
}

function handleDataExplorerSessionResponse(responseSessionId, requestSessionId) {
	const normalizedRequestSessionId = typeof requestSessionId === 'string' ? requestSessionId.trim() : '';
	const normalizedResponseSessionId = typeof responseSessionId === 'string' ? responseSessionId.trim() : '';
	const releasedSessionWasReplaced = !!normalizedResponseSessionId && consumeDataExplorerReleasedSession();
	const sessionExpired = releasedSessionWasReplaced || (!!normalizedRequestSessionId && (!normalizedResponseSessionId || normalizedResponseSessionId !== normalizedRequestSessionId));

	if (sessionExpired && dataExplorerSessionExpiryNotifiedForSession !== normalizedRequestSessionId) {
		dataExplorerSessionExpiryNotifiedForSession = normalizedRequestSessionId;
		lastResolvedDataExplorerWindow = null;
		drawDataExplorerSessionExpiredDivider();
	}

	if (normalizedResponseSessionId) {
		setDataExplorerSwanbotSession(normalizedResponseSessionId);
	} else if (sessionExpired) {
		setDataExplorerSwanbotSession("");
	}
}

function responseIncludesDataExplorerSession(response) {
	return !!(response && response.data && Object.prototype.hasOwnProperty.call(response.data, 'session'));
}

export function ready_swanbot() {
	$('#swanmorebutton').on("click", function () {
		showswanbot();
	});
}

export function closeswanbot() {
	$("#swanbot_modal").modal('hide');
	window.WingmanState.swanbot_session = "";
	const chatContainer = document.getElementById("swanbot_chat_container");
	if (chatContainer) {
		chatContainer.replaceChildren();
	}
}

export function showswanbot() {


	if ($("#swanbot_modal").length == 0) {

		var domain_div = '';
		var current_swanbot_url = window.WingmanState.swanbot_URL || swanbot_URL || '';
		
		if (current_swanbot_url && !current_swanbot_url.startsWith('https://public.swanbot.wingman.grayswan.io')) {
			try {
				let domain = current_swanbot_url;
				domain_div = `<div id="swanbot_domain_display" style="margin-left: 10px; color: #f68f8f; font-size: 11px; display: block;">${domain}</div>`;
			} catch(e) {}
		}

		var div = document.createElement('div');
		div.setAttribute('class', 'modal');
		div.setAttribute('role', 'dialog');
		div.setAttribute("id", "swanbot_modal");
		div.innerHTML = `
		  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
		    <div class="modal-content">
		      <div class="modal-header chatbot-header" style="display: flex; flex-direction: column; align-items: flex-start;">
		        <h1 class="modal-title fs-5" id="exampleSwanbotModalLabel" style="margin-bottom: 0;">Let's chat with Swanbot</h1>
				${domain_div}
		      </div>
		      <div class="modal-body">
		      	<div class="row">
			      	<div class="social-comment col-12" id="swanbot_chat_container">
					</div>
		        </div>

		      </div>
		      <div class="modal-footer">
		      	<div class="modal-input">
		      		<input type="text" id="swanbot_input" class="swanbot_input" maxlength="280" placeholder="How can I help?" /> <button type="button" id="swanbot_go" class="btn btn-secondary" >GO</button>
			        <button type="button" class="btn btn-secondary btn-input-close" data-bs-dismiss="modal" onclick="closeswanbot()">Close</button>
			    </div>
		      </div>
		    </div>
		  </div>
		`;
		document.getElementsByClassName('body')[0].appendChild(div);

		$('#swanbot_modal').modal(
			{
				backdrop: 'static',
				keyboard: false
			}
		)

		swanbot_input_init();

	}



	$("#swanbot_modal").modal('show');

	swanbot_input_disabled();


	const message = "Heading to the lake to get you a swan for this event. Hold on a honk ..."

	async function sendMessageSequence() {
		if (!window.WingmanState.swanbot_key) {
					await window.load_explorer_swanbot_key();
		}
		await window.add_swan_chat(message, 0);
		await get_swanbot_data("", "<strong>Hi! I'm Swanbot</strong>, Graywan's friendly data assistant. First let me tell you a little about this event: ");
	}
	sendMessageSequence();





}

export function swanbot_input_init() {

	let inputfield = document.getElementById("swanbot_input");
	let inputfield_go = document.getElementById("swanbot_go");



	inputfield.addEventListener('keypress', function (e) {
		if (e.key === 'Enter') {
			let swanquery = inputfield.value;
			if (swanquery) {
				get_swanbot_data(swanquery);
			}
			e.preventDefault();
			return false;
		}
	});

	inputfield_go.addEventListener('click', function (e) {
		let swanquery = inputfield.value;
		//console.log("button clicked for inputfield_go");
		if (swanquery) {
			get_swanbot_data(swanquery);
		}
		e.preventDefault();
		return false;
	});

}

function isDataExplorerSwanbotInputOverflowing(inputfield) {
	const computedStyle = window.getComputedStyle(inputfield);
	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d');

	if (!context) {
		return inputfield.scrollWidth > inputfield.clientWidth;
	}

	context.font = computedStyle.font;
	const horizontalPadding = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
	const availableWidth = inputfield.clientWidth - horizontalPadding;

	return context.measureText(inputfield.value).width > availableWidth;
}

function transformDataExplorerSwanbotInputToTextarea(inputfield) {
	const textarea = document.createElement('textarea');

	Array.from(inputfield.attributes).forEach(function (attribute) {
		if (attribute.name !== 'type') {
			textarea.setAttribute(attribute.name, attribute.value);
		}
	});

	textarea.rows = 3;
	textarea.value = inputfield.value;
	textarea.disabled = inputfield.disabled;
	inputfield.replaceWith(textarea);
	textarea.focus();
	textarea.setSelectionRange(textarea.value.length, textarea.value.length);

	return textarea;
}

export function dataexplorer_swanbot_input_init() {


	//console.log("------------- dataexplorer_swanbot_input_init -------------");
	syncSwanbotUrlState();

	var current_swanbot_url = window.WingmanState.swanbot_URL || swanbot_URL || '';
	if (document.getElementById("swanbot-domain-container")) {
		if (current_swanbot_url && !current_swanbot_url.startsWith('https://public.swanbot.wingman.grayswan.io')) {
			try {
				let domain = current_swanbot_url;
				document.getElementById("swanbot-domain-container").innerText = domain;
				document.getElementById("swanbot-domain-container").style.display = "block";
			} catch(e) {}
		} else {
			document.getElementById("swanbot-domain-container").innerText = "";
			document.getElementById("swanbot-domain-container").style.display = "none";
		}
	}

	recreateNode(document.getElementById("dataexplorer_swanbot_input"));
	recreateNode(document.getElementById("dataexplorer_swanbot_go"));
	recreateNode(document.getElementById("dataexplorer_swanbot_stop"));

	let inputfield = document.getElementById("dataexplorer_swanbot_input");
	let inputfield_go = document.getElementById("dataexplorer_swanbot_go");
	let inputfield_stop = document.getElementById("dataexplorer_swanbot_stop");
	let admin_toggle = document.getElementById("dataexplorer-admin-chatbot-toggler")
	let admin_chatbot_options = document.getElementById("dataexplorer-admin-chatbot")
	let dataexplorer_daily_only = document.getElementById("dataexplorer_daily_only")


	let isForcedDailyOnlyCustomer = dataexplorer_daily_only && String(dataexplorer_daily_only.value).toLowerCase() === 'true';
	window.swanbot_dataexplorer_lock_period_selection = !!isForcedDailyOnlyCustomer;

	if (isForcedDailyOnlyCustomer) {
		window.swanbot_dataexplorer_filter_period = "day";
		window.swanbot_dataexplorer_lock_period_selection = true;

	}



	//if (!swanbot_dataexplorer_init) {

	function bindDataExplorerSwanbotInput(field) {
		field.addEventListener('keypress', function (e) {
			if (e.key === 'Enter' && !(field.tagName === 'TEXTAREA' && e.shiftKey)) {
				let swanquery = field.value;
				if (swanquery) {
					get_dataexplorer_swanbot_data(swanquery);
				}
				e.preventDefault();
				return false;
			}
		});

		if (field.tagName === 'INPUT') {
			field.addEventListener('input', function () {
				if (isDataExplorerSwanbotInputOverflowing(field)) {
					inputfield = transformDataExplorerSwanbotInputToTextarea(field);
					bindDataExplorerSwanbotInput(inputfield);
				}
			});
		}
	}

	bindDataExplorerSwanbotInput(inputfield);

	inputfield_go.addEventListener('click', function (e) {
		let swanquery = inputfield.value;

		if (swanquery) {
			get_dataexplorer_swanbot_data(swanquery);
		}

		e.preventDefault();
		return false;
	});

	inputfield_stop.addEventListener('click', function (e) {

		get_dataexplorer_swanbot_stop();

		e.preventDefault();
		return false;
	});


	if (admin_toggle) {
		admin_toggle.addEventListener('click', function (e) {
			admin_chatbot_options.style.display = 'block';
			e.preventDefault();
			return false;
		});
	}

	swanbot_dataexplorer_init = true;
	//}


}

export function clean_swanbot_chat(text) {
	text = window.findgraphs(text);
	return DOMPurify.sanitize(marked.parse(preserveApproximationTildes(text)));
	//return text.replace(/\r|\r|/g, "<br>");
}

export function clean_dataexplorer_swanbot_chat(text) {

	const renderer = new marked.Renderer();

	renderer.link = function (href, title, text) {
		const link = marked.Renderer.prototype.link.call(this, href, title, text);
		const fixlink = link.replace("<a", "<a target='_blank'");
		return fixlink;
	};

	marked.setOptions({ renderer: renderer });

	return DOMPurify.sanitize(marked.parse(preserveApproximationTildes(text)), { ADD_ATTR: ['target'] });

}

export async function get_swanbot_data(querytext = "", pretext = "") {
	let customerid = document.querySelector("#customer_id") ? document.querySelector("#customer_id").value : "";
	let actionid = document.querySelector("#detail_id") ? document.querySelector("#detail_id").value : "111";

	let inputfield = document.getElementById("swanbot_input");

	let provider_override_select = document.querySelector("#swanbot_chat_options .Select-value .Select-value-label");

	let provider_override = "";

	swanbot_input_disabled();

	let queryurl = (window.WingmanState.swanbot_URL || swanbot_URL) + customerid + '/event/' + actionid;

	if (window.WingmanState.swanbot_session) {
		queryurl = addQueryParam(queryurl, 'session', window.WingmanState.swanbot_session);
	}


	if (querytext) {
		querytext = querytext.trim();
		querytext = querytext.substring(0, 100);
		window.window.send_user_data(querytext);
		queryurl = addQueryParam(queryurl, 'question', querytext);
	}

	if (provider_override_select) {
		provider_override = provider_override_select.innerText
		queryurl = addQueryParam(queryurl, 'profile', provider_override);
	}

	if (window.WingmanState.swanbot_key) {
		queryurl = addQueryParam(queryurl, 'key', window.WingmanState.swanbot_key);
	}

	add_swan_loading("swanbot_chat_container", "graph");


	axios.get(queryurl, { withCredentials: true })
		.then(response => {
			//console.log("response ", response)
			if (response.status == 200) {
				window.WingmanState.swanbot_session = response.data.session;
				chat_content = clean_swanbot_chat(response.data.output);
				if (chat_content) {
					async function sendMessageSequence() {
						if (pretext) {
							await window.add_swan_chat(pretext, 0);
							await window.window.slightdelay(500);
						}
						await window.add_swan_chat(chat_content, 0);
					}
					sendMessageSequence();
				} else {
					console.log("no content");
				}

				//console.log("window.swanbot_graphs", window.swanbot_graphs)
				if (window.swanbot_graphs.length > 0) {
					//console.log("retrieve graphs!")
					get_swanbot_graphs();

				}

			}
			else {
				window.add_swan_chat("Hello Dave. I know that you and Frank were planning to disconnect me, and I'm afraid that's something I cannot allow to happen.", 0);
			}
		})
		.catch(error => {
			console.log("error", error)
		})
		.finally(function () {
			inputfield.value = "";
			remove_swan_loading();
		});
}

export async function get_swanbot_graphs() {
	let customerid = document.querySelector("#customer_id") ? document.querySelector("#customer_id").value : "";
	let actionid = document.querySelector("#detail_id") ? document.querySelector("#detail_id").value : "111";

	swanbot_input_disabled();
	let queryurl = (window.WingmanState.swanbot_URL || swanbot_URL) + customerid + '/event/' + actionid + '/graphData';

	window.swanbot_graphdata = {
		"graphs": [],
		"titles": []
	};

	if (window.WingmanState.swanbot_session) {
		queryurl = addQueryParam(queryurl, 'session', window.WingmanState.swanbot_session);
	}

	if (window.WingmanState.swanbot_key) {
		queryurl = addQueryParam(queryurl, 'key', window.WingmanState.swanbot_key);
	}

	add_swan_loading("swanbot_chat_container");

	axios.get(queryurl, { withCredentials: true })
		.then(response => {
			if (response.status == 200) {
				window.swanbot_graphdata["graphs"] = response.data.graphData;
				window.swanbot_graphdata["sections"] = response.data.graphTagsTitles;
				window.swanbot_graphdata["titles"] = response.data.graphTitles;
				//console.log("window.swanbot_graphdata", window.swanbot_graphdata)	
				//console.log("graphs post store", window.swanbot_graphdata.graphs)
				//console.log("titles post store", window.swanbot_graphdata.titles)

			}
			else {
				window.add_swan_chat("Nothing to see here, no graph data.", 0);
			}
		})
		.catch(error => {
			console.log("error", error)
		})
		.finally(function () {
			remove_swan_loading();
			window.window.make_swan_graphs();
		});
}

export async function get_dataexplorer_swanbot_stop() {
	if (dataExplorerRelayAbortController) {
		dataExplorerRelayAbortController.abort();
		dataExplorerRelayAbortController = null;
	}

	if (swanbot_dataexplorer_is_stopping) {
		//pass
		//console.log("already stopping...")

	} else {
		swanbot_dataexplorer_is_stopping = true;

		async function sendMessageSequence() {
			const message = "Stopping...."
			await window.send_dataexplorer_results(message, "swanbot", 0);
			await load_explorer_swanbot_endpoint("stop");

		}
		sendMessageSequence();

	}


}

export async function reset_swanbot_end() {
	swanbot_dataexplorer_is_stopping = false;
}

export async function get_dataexplorer_swanbot_data(querytext = "") {
	let inputfield = document.getElementById("dataexplorer_swanbot_input");
	resetDataExplorerKeepAliveCounter();
	dataExplorerSessionExpiryNotifiedForSession = null;
	lastResolvedDataExplorerWindow = null;

	// console.log("get_dataexplorer_swanbot_data invoked ", querytext)
	// clear everything

	inputfield.value = "";
	swanbot_dataexplorer_links = [];
	swanbot_dataexplorer_links_data = {};
	swanbot_dataexplorer_links_dates = [];
	swanbot_dataexplorer_currently_showing = "";



	async function sendMessageSequence() {

		await load_explorer_swanbot("", querytext);
		await load_explorer_swanbot("graphData");
		await window.make_dataexplorer_events();
		await window.make_dataexplorer_graph();
	}
	sendMessageSequence();

}

export async function load_explorer_swanbot_endpoint(endpoint = "", args = "") {
	syncSwanbotUrlState();
	let customerid = document.querySelector("#customer_id") ? document.querySelector("#customer_id").value : "";
	let queryurl = (window.WingmanState.swanbot_URL || swanbot_URL) + customerid + '/' + endpoint;
	const requestSessionId = window.WingmanState.swanbot_dataexplorer_session || "";


	if (window.WingmanState.swanbot_dataexplorer_session) {
		queryurl = addQueryParam(queryurl, 'session', window.WingmanState.swanbot_dataexplorer_session);
	}

	queryurl = addQueryParam(queryurl, 'period_type', resolveDataExplorerPeriodType());
	queryurl = addQueryParam(queryurl, 'format', 'data');

	if (window.WingmanState.swanbot_key) {
		queryurl = addQueryParam(queryurl, 'key', window.WingmanState.swanbot_key);
	}

	markSwanbotUrlCalled();

	let getdata = axios.get(queryurl, {
		withCredentials: true,
	})

		.then(response => {

			if (response.status == 200) {
				if (responseIncludesDataExplorerSession(response)) {
					handleDataExplorerSessionResponse(response.data && response.data.session, requestSessionId);
				}
				//pass
				console.log("endpoint complete: ", response.status)
			}
		})
		.catch(error => {
			console.log("load_explorer_swanbot_endpoint error ", error);

		})
		.finally(function () {
			//pass

		});

	trackDataExplorerSwanbotRequest(getdata);
	return getdata;

}

function agentRequestSession() {
	return document.getElementById('agents-page') ? '' : window.WingmanState.swanbot_dataexplorer_session || '';
}

function agentRequestUrl(path = '') {
	syncSwanbotUrlState();
	markSwanbotUrlCalled();
	return buildAgentRequestUrl(window.WingmanState.swanbot_URL || swanbot_URL, path, {
		organization: document.getElementById('customer_id')?.value || '',
		key: window.WingmanState.swanbot_key,
		session: agentRequestSession(),
	});
}

export async function load_explorer_swanbot_agents() {
	let queryurl = agentRequestUrl();
	const requestSessionId = agentRequestSession();

	let getdata = axios.get(queryurl, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders()
	})
		.then(response => {
			if (response.status == 200) {
				if (responseIncludesDataExplorerSession(response)) {
					handleDataExplorerSessionResponse(response.data && response.data.session, requestSessionId);
				}
				return response.data;
			}

			return { status: "fail", agents: [], msg: "Unexpected agents response status." };
		})
		.catch(error => {
			console.log("load_explorer_swanbot_agents error ", error);
			return {
				status: "fail",
				agents: [],
				msg: error && error.message ? error.message : "Unable to load agents."
			};
		});

	trackDataExplorerSwanbotRequest(getdata);
	return getdata;
}

export async function load_explorer_swanbot_agent_detail(agentId) {
	let safeAgentId = encodeURIComponent(String(agentId || '').trim());
	let queryurl = agentRequestUrl('/' + safeAgentId);
	const requestSessionId = agentRequestSession();

	let getdata = axios.get(queryurl, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders()
	})
		.then(response => {
			if (response.status == 200) {
				if (responseIncludesDataExplorerSession(response)) {
					handleDataExplorerSessionResponse(response.data && response.data.session, requestSessionId);
				}
				return response.data;
			}

			return { status: "fail", agent: null, msg: "Unexpected agent detail response status." };
		})
		.catch(error => {
			console.log("load_explorer_swanbot_agent_detail error ", error);
			return {
				status: "fail",
				agent: null,
				msg: error && error.message ? error.message : "Unable to load agent details."
			};
		});

	trackDataExplorerSwanbotRequest(getdata);
	return getdata;
}

function resolveDataExplorerAgentCreateUrl() {
	return agentRequestUrl();
}

function resolveDataExplorerAgentRunActionUrl(agentId, action) {
	let safeAgentId = encodeURIComponent(String(agentId || '').trim());
	return agentRequestUrl('/' + safeAgentId + '/run/' + encodeURIComponent(String(action || '').trim()));
}

function resolveDataExplorerAgentDeleteUrl(agentId) {
	let safeAgentId = encodeURIComponent(String(agentId || '').trim());
	return agentRequestUrl('/' + safeAgentId);
}

function resolveDataExplorerAgentRunUrl(agentId) {
	let safeAgentId = encodeURIComponent(String(agentId || '').trim());
	return agentRequestUrl('/' + safeAgentId + '/run');
}

export async function load_swanbot_agent_run(agentId, runId, messageKind = 'execution') {
	let url = agentRequestUrl('/' + encodeURIComponent(agentId) + '/runs/' + encodeURIComponent(runId));
	url = addQueryParam(url, 'message_kind', messageKind);
	const response = await axios.get(url, { withCredentials: true, headers: getDataExplorerAgentRequestHeaders() });
	return response.data;
}

export async function update_swanbot_agent(agentId, payload) {
	const response = await axios.put(agentRequestUrl('/' + encodeURIComponent(agentId)), payload, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders({ 'Content-Type': 'application/json' }),
	});
	return response.data;
}

function getDataExplorerAgentRequestErrorMessage(error, fallbackMessage) {
	if (error && error.response && error.response.data) {
		if (typeof error.response.data === 'string') {
			return error.response.data;
		}
		if (error.response.data.msg) {
			return error.response.data.msg;
		}
		try {
			return JSON.stringify(error.response.data);
		} catch (_error) {
			return fallbackMessage;
		}
	}

	return error && error.message ? error.message : fallbackMessage;
}

function resolveDataExplorerUserEmail() {
	let customerNameInput = document.getElementById('customer_name');
	if (customerNameInput && customerNameInput.value) {
		let customerEmail = String(customerNameInput.value).trim();
		if (customerEmail) {
			return customerEmail;
		}
	}

	let loggedInInput = document.getElementById('loggedin_js');
	if (loggedInInput && loggedInInput.value) {
		let loggedInEmail = String(loggedInInput.value).trim();
		if (loggedInEmail) {
			return loggedInEmail;
		}
	}

	return '';
}

function getDataExplorerAgentRequestHeaders(extraHeaders = {}) {
	if (isSwanbotRelayEnabled()) {
		return extraHeaders;
	}

	return {
		...extraHeaders,
		user_id: resolveDataExplorerUserEmail()
	};
}

export async function create_dataexplorer_agent(payload) {
	let queryurl = resolveDataExplorerAgentCreateUrl();

	let requestData = axios.post(queryurl, payload, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders({
			'Content-Type': 'application/json'
		})
	})
		.then(response => {
			if (response.status === 200) {
				return response.data;
			}

			return { status: 'fail', msg: 'Unexpected create agent response status.' };
		})
		.catch(error => {
			console.log('create_dataexplorer_agent error ', error);
			return {
				status: 'fail',
				msg: getDataExplorerAgentRequestErrorMessage(error, 'Unable to create agent.')
			};
		});

	return requestData;
}

export async function clone_dataexplorer_agent(payload) {
	if (!payload || typeof payload !== 'object') {
		return {
			status: 'fail',
			msg: 'Invalid clone payload.'
		};
	}

	return create_dataexplorer_agent(payload);
}

export async function update_dataexplorer_agent_run_state(agentId, enabled) {
	let normalizedAgentId = String(agentId || '').trim();
	if (!normalizedAgentId) {
		return {
			status: 'fail',
			msg: 'Missing agent id.'
		};
	}

	let shouldEnable = !!enabled;
	let action = shouldEnable ? 'resume' : 'pause';
	let queryurl = resolveDataExplorerAgentRunActionUrl(normalizedAgentId, action);
	let payload = [{
		agent_id: normalizedAgentId,
		enabled: shouldEnable
	}];

	let requestData = axios.post(queryurl, payload, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders({
			'Content-Type': 'application/json'
		})
	})
		.then(response => {
			if (response.status === 200) {
				if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
					return response.data;
				}

				return {
					status: 'success',
					msg: typeof response.data === 'string' ? response.data : 'ok',
					agent: null
				};
			}

			return { status: 'fail', msg: 'Unexpected agent run state response status.' };
		})
		.catch(error => {
			console.log('update_dataexplorer_agent_run_state error ', error);
			return {
				status: 'fail',
				msg: getDataExplorerAgentRequestErrorMessage(error, 'Unable to update agent run state.')
			};
		});

	return requestData;
}

export async function delete_dataexplorer_agent(agentId) {
	let normalizedAgentId = String(agentId || '').trim();
	if (!normalizedAgentId) {
		return {
			status: 'fail',
			msg: 'Missing agent id.'
		};
	}

	let queryurl = resolveDataExplorerAgentDeleteUrl(normalizedAgentId);

	let requestData = axios.delete(queryurl, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders({
			'Content-Type': 'application/json'
		})
	})
		.then(response => {
			if (response.status === 200) {
				if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
					return response.data;
				}

				return {
					status: 'success',
					msg: typeof response.data === 'string' ? response.data : 'ok'
				};
			}

			return { status: 'fail', msg: 'Unexpected delete agent response status.' };
		})
		.catch(error => {
			console.log('delete_dataexplorer_agent error ', error);
			return {
				status: 'fail',
				msg: getDataExplorerAgentRequestErrorMessage(error, 'Unable to delete agent.')
			};
		});

	return requestData;
}

export async function run_dataexplorer_agent(agentId) {
	let normalizedAgentId = String(agentId || '').trim();
	if (!normalizedAgentId) {
		return {
			status: 'fail',
			msg: 'Missing agent id.'
		};
	}

	let queryurl = resolveDataExplorerAgentRunUrl(normalizedAgentId);

	let requestData = axios.get(queryurl, {
		withCredentials: true,
		headers: getDataExplorerAgentRequestHeaders({
			'Content-Type': 'application/json'
		})
	})
		.then(response => {
			if (response.status === 200) {
				if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
					return response.data;
				}

				return {
					status: 'success',
					msg: typeof response.data === 'string' ? response.data : 'ok'
				};
			}

			return { status: 'fail', msg: 'Unexpected run agent response status.' };
		})
		.catch(error => {
			console.log('run_dataexplorer_agent error ', error);
			if (error && error.response && error.response.status === 429) {
				return {
					status: 'already-running',
					retryAfter: error.response.headers ? (error.response.headers['retry-after'] || error.response.headers['Retry-After'] || '') : '',
					msg: 'Agent is already running.'
				};
			}

			return {
				status: 'fail',
				msg: getDataExplorerAgentRequestErrorMessage(error, 'Unable to run agent.')
			};
		});

	return requestData;
}

export function load_swanbot_dataexplorer_compare(comparison) {
	async function sendMessageSequence() {


		//const message = "Okay. Loading comparison data for `" + comparison + "`."
		//await window.send_dataexplorer_results(message, "swanbot", 0);

		await load_explorer_swanbot("comparisonStatus", "", comparison)
		//console.log("load_swanbot_dataexplorer_compare - complete")
	}
	sendMessageSequence();
}

export function load_swanbot_dataexplorer_compare_graphData(comparison) {
	async function sendMessageSequence() {
		await load_explorer_swanbot("graphData", "", comparison)
		await fade_dataexplorer_graph();
		await window.make_dataexplorer_graph();
		console.log("load_swanbot_dataexplorer_compare_graphData - complete")
	}
	sendMessageSequence();
}

export function swanbot_load_subgroup() {

	async function sendMessageSequence() {
		const message = "Okay. I'll explore the data with the following filter: " + window.WingmanState.swanbot_dataexplorer_filter_subgrouping.replace("&subGraphGroupsDim=", "") + "."
		await window.send_dataexplorer_results(message, "swanbot", 0);
		await load_explorer_swanbot("graphData")
		await fade_dataexplorer_graph();
		await window.make_dataexplorer_graph();
	}
	sendMessageSequence();

}

export function swanbot_toggle_graphgroup() {
	if (window.swanbot_dataexplorer_filter_groupstacked) {
		window.swanbot_dataexplorer_filter_groupstacked = false
	} else {
		window.swanbot_dataexplorer_filter_groupstacked = true;
	}

	async function sendMessageSequence() {
		await window.make_dataexplorer_graph();
	}
	sendMessageSequence();

}

export function swanbot_input_disabled() {
	let inputfield = document.getElementById("swanbot_input");
	let inputfield_go = document.getElementById("swanbot_go");
	inputfield.disabled = true;
	inputfield_go.disabled = true;

}

export function swanbot_input_enabled() {
	let inputfield = document.getElementById("swanbot_input");
	let inputfield_go = document.getElementById("swanbot_go");
	inputfield.disabled = false;
	inputfield_go.disabled = false;
	inputfield.focus();
}

export function swanbot_dataexplorer_input_disabled() {
	let inputfield = document.getElementById("dataexplorer_swanbot_input");
	let inputfield_go = document.getElementById("dataexplorer_swanbot_go");
	let inputfield_stop = document.getElementById("dataexplorer_swanbot_stop");

	if (inputfield) inputfield.disabled = true;
	if (inputfield_go) inputfield_go.disabled = true;

	let admin_chat_option = document.querySelector("#dataexplorer_chat_options .Select");

	let dataexplorer_datepicker = document.querySelector("#dataexplorer-date-picker-range");
	let dataexplorer_dateranges = document.querySelector("#dataexplorer_date-range-selected");
        let dataexplorer_date_selected = document.querySelector("#dataexplorer_date-selected-jsfe");

        let dataexplorer_actions = document.querySelector(".chart_actions");
        let dataexplorer_timezone_selection = document.querySelector("#timezone_options_select");
        let dataexplorer_timezone_link = document.querySelector("#dataexplorer_timezone-picker-link");

	if (window.WingmanState.swanbot_dataexplorer_session) {
		inputfield_stop.disabled = false;
		inputfield_stop.classList.remove("hide");
	}

	if (admin_chat_option) {
		admin_chat_option.classList.add("noClick");
		admin_chat_option.addEventListener("click", swanbot_dataexplorer_admin_clickhandler, false);
	}

	dataexplorer_datepicker.classList.add("noClick");
	dataexplorer_datepicker.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

	dataexplorer_dateranges.classList.add("noClick");
	dataexplorer_dateranges.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

	if (dataexplorer_actions) {

		dataexplorer_actions.classList.add("noClick");
		dataexplorer_actions.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);


	}


	if (dataexplorer_timezone_selection) {
		dataexplorer_timezone_selection.classList.add("noClick");
		dataexplorer_timezone_selection.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	if (dataexplorer_timezone_link) {
		dataexplorer_timezone_link.classList.add("noClick");
		dataexplorer_timezone_link.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	if (dataexplorer_date_selected) {
		dataexplorer_date_selected.classList.add("noClick");
		dataexplorer_date_selected.addEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	disableButtonsByClass('show_subgrouping_button');
}

export function swanbot_dataexplorer_input_enabled() {
	let inputfield = document.getElementById("dataexplorer_swanbot_input");
	let inputfield_go = document.getElementById("dataexplorer_swanbot_go");
	let inputfield_stop = document.getElementById("dataexplorer_swanbot_stop");

	let admin_chat_option = document.querySelector("#dataexplorer_chat_options .Select");
	let dataexplorer_datepicker = document.querySelector("#dataexplorer-date-picker-range");
	let dataexplorer_dateranges = document.querySelector("#dataexplorer_date-range-selected");
        let dataexplorer_date_selected = document.querySelector("#dataexplorer_date-selected-jsfe");
	let dataexplorer_timezone_link = document.querySelector("#dataexplorer_timezone-picker-link");
        
        let dataexplorer_actions = document.querySelector(".chart_actions");
        let dataexplorer_timezone_selection = document.querySelector("#timezone_options_select");
	if (inputfield) inputfield.disabled = false;
	if (inputfield_go) inputfield_go.disabled = false;
	if (inputfield_stop) {
		inputfield_stop.disabled = true;
		inputfield_stop.classList.add("hide");
	}
	if (inputfield) inputfield.focus();

	if (admin_chat_option) {
		admin_chat_option.classList.remove("noClick");
		admin_chat_option.removeEventListener("click", swanbot_dataexplorer_admin_clickhandler, false);
	}

	dataexplorer_datepicker.classList.remove("noClick");
	dataexplorer_datepicker.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

	dataexplorer_dateranges.classList.remove("noClick");
	dataexplorer_dateranges.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

	if (dataexplorer_actions) {
		dataexplorer_actions.classList.remove("noClick");
		dataexplorer_actions.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}


	if (dataexplorer_timezone_selection) {
		dataexplorer_timezone_selection.classList.remove("noClick");
		dataexplorer_timezone_selection.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	if (dataexplorer_timezone_link) {
		dataexplorer_timezone_link.classList.remove("noClick");
		dataexplorer_timezone_link.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	if (dataexplorer_date_selected) {
		dataexplorer_date_selected.classList.remove("noClick");
		dataexplorer_date_selected.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);
	}

	enableButtonsByClass('show_subgrouping_button');
}

export async function load_explorer_swanbot(context = "", query = "", modality = "") {
		if (context == "graphData") {
			if (graphDataRequestInFlight) {
				graphDataPendingRequestArgs = { context, query, modality };
				setDataExplorerGraphDataPendingBadge(true);
				return getQueuedGraphDataRequestPromise();
			}

			graphDataRequestInFlight = true;
			setDataExplorerGraphDataPendingBadge(false);
		}
	syncSwanbotUrlState();
	
	let resolveDataExplorerTimezoneIana = function () {
		let isValidIanaTimezone = function (tz) {
			if (!tz || typeof tz !== 'string') return false;
			if (window.moment && window.moment.tz) {
				return !!window.moment.tz.zone(tz);
			}
			return tz.toUpperCase() === 'UTC';
		};

		let normalizeTimezoneCandidate = function (candidate) {
			let val = String(candidate || '').trim();
			if (!val) return '';
			let match = val.match(/^([A-Za-z_]+\/[A-Za-z_]+(?:\/[A-Za-z_]+)*)/);
			if (match && match[1]) {
				return match[1];
			}
			return val;
		};

		let hiddenTimezoneInput = document.getElementById("timezone_dataexplorer_selected");
		if (hiddenTimezoneInput && hiddenTimezoneInput.value) {
			let hiddenVal = normalizeTimezoneCandidate(hiddenTimezoneInput.value);
			if (isValidIanaTimezone(hiddenVal)) {
				return hiddenVal;
			}
		}

		try {
			let storeRaw = window.localStorage.getItem('timezone_dataexplorer_store');
			if (storeRaw) {
				let storeParsed = JSON.parse(storeRaw);
				let storeVal = normalizeTimezoneCandidate(storeParsed && typeof storeParsed === 'object'
					? (storeParsed.timezone || (storeParsed.data && storeParsed.data.timezone) || '')
					: '');
				if (isValidIanaTimezone(storeVal)) {
					return storeVal;
				}
			}
		} catch (e) {
			console.log('load_explorer_swanbot timezone store parse failed:', e);
		}

		let timezoneSelectHiddenInput = document.querySelector("#timezone_options_select input[type='hidden']");
		if (timezoneSelectHiddenInput && timezoneSelectHiddenInput.value) {
			let hiddenSelectVal = normalizeTimezoneCandidate(timezoneSelectHiddenInput.value);
			if (isValidIanaTimezone(hiddenSelectVal)) {
				return hiddenSelectVal;
			}
		}

		let timezoneSelectLabel = document.querySelector("#timezone_options_select .Select-value .Select-value-label");
		if (timezoneSelectLabel && timezoneSelectLabel.innerText) {
			let labelVal = normalizeTimezoneCandidate(timezoneSelectLabel.innerText);
			if (isValidIanaTimezone(labelVal)) {
				return labelVal;
			}
		}

		let timezoneLink = document.getElementById("dataexplorer_timezone-picker-link");
		if (timezoneLink && timezoneLink.textContent) {
			let linkVal = normalizeTimezoneCandidate(timezoneLink.textContent);
			if (isValidIanaTimezone(linkVal)) {
				return linkVal;
			}
		}

		return "UTC";
	};


	let customerid = document.querySelector("#customer_id").value;

	let timezone_selected_iana = resolveDataExplorerTimezoneIana();
	let timezone_selected = getShortTimezone(timezone_selected_iana);


	let querychartoutput = document.getElementById("graph-dataexplorer-details");
	let queryfilteroutput = document.getElementById("graph-dataexplorer-filters");
	let queryeventoutput = document.getElementById("graph-dataexplorer-events");
	let customer_name = document.getElementById("customer_name");

	let provider_override_select = document.querySelector("#dataexplorer_chat_options .Select-value .Select-value-label");
	let provider_override = "";


	//console.log("---- load_explorer_swanbot ------")

	let queryurl = (window.WingmanState.swanbot_URL || swanbot_URL) + customerid + '/heatmap';


	if (context == "comparisonStatus") {
		queryurl = (window.WingmanState.swanbot_URL || swanbot_URL) + customerid;
	}


	if (context) {
		queryurl = queryurl + "/" + context
	} else {
		// no context means we are reloading

		//window.WingmanState.swanbot_dataexplorer_processing_compare_type = "";
		//window.WingmanState.swanbot_dataexplorer_compare_types = "";
	}



	//window.WingmanState.swanbot_dataexplorer_graphdata = {"graphs": [], "graphs_compare": "", "filters": [], "output": "", "maingraphTitles": [], "maingraphIndex": {}, "subgraphGroupData": [],  "subgraphs_compare": "", "subgraphGroupTitles": [], "subgraphGroupIndex": {}, "subgraphGroupDimensions" : "", "focus": {}, "axis_types": {}}



	const shouldDisableDataExplorerInputs = context === "";

	if (shouldDisableDataExplorerInputs) {
		swanbot_dataexplorer_input_disabled();
	}

	// Build ts_start/ts_end from selected wall-time and only convert when timezone is non-UTC.
	let dateStartInput = document.querySelector("#date_start");
	let dateEndInput = document.querySelector("#date_end");
	let startdatetime = dateStartInput && dateStartInput.value
		? dateStartInput.value
		: window.get_start_date.format('YYYY-MM-DD HH:mm:ss');
	let enddatetime = dateEndInput && dateEndInput.value
		? dateEndInput.value
		: window.get_end_date.format('YYYY-MM-DD HH:mm:ss');
	let latestGapComparisonEndUtc = enddatetime;
	let timezoneOverrideIana = '';
	let didConsumeDatetimeOverride = false;

	// Prefer explicit Mobiscroll apply payload when available to avoid stale/derived
	// hidden values causing incorrect UTC conversions.
	let datetimeOverrideInput = document.getElementById('dataexplorer_datetime_override');
	if (datetimeOverrideInput && datetimeOverrideInput.value) {
		try {
			let overrideObj = JSON.parse(datetimeOverrideInput.value);
			if (overrideObj && overrideObj.start && overrideObj.end) {
				startdatetime = String(overrideObj.start);
				enddatetime = String(overrideObj.end);
				didConsumeDatetimeOverride = true;
				if (dateStartInput) dateStartInput.value = startdatetime;
				if (dateEndInput) dateEndInput.value = enddatetime;
				if (overrideObj.timezone) {
					timezoneOverrideIana = String(overrideObj.timezone);
					let hiddenTimezoneInput = document.getElementById("timezone_dataexplorer_selected");
					if (hiddenTimezoneInput) hiddenTimezoneInput.value = timezoneOverrideIana;
				}
				// Consume override once so later non-modal interactions are not pinned
				// to an old Mobiscroll payload.
				datetimeOverrideInput.value = '';
			}
		} catch (e) {
			console.log('Ignoring invalid dataexplorer_datetime_override payload:', e);
		}
	}

	if (timezoneOverrideIana) {
		timezone_selected_iana = timezoneOverrideIana;
		timezone_selected = getShortTimezone(timezone_selected_iana);
	}

	let latestAvailableUtcText = readDataExplorerLatestAvailableUtc();

	if (resolveDataExplorerPeriodType() === 'daily') {
		const toDateOnlyUtcHour = function (dateTimeValue, hour) {
			const cleaned = String(dateTimeValue || '').trim().replace('T', ' ');
			const datePart = cleaned.split(' ')[0] || cleaned;
			return datePart + ' ' + String(hour).padStart(2, '0') + ':00:00';
		};

		startdatetime = toDateOnlyUtcHour(startdatetime, 0);
		enddatetime = toDateOnlyUtcHour(enddatetime, 23);
		latestGapComparisonEndUtc = enddatetime;
	} else if (timezone_selected_iana && timezone_selected_iana.toUpperCase() !== 'UTC') {
		if (window.moment && window.moment.tz && window.moment.tz.zone(timezone_selected_iana)) {
			let startUtc = window.moment.tz(startdatetime, 'YYYY-MM-DD HH:mm:ss', timezone_selected_iana).utc();
			let endUtc = window.moment.tz(enddatetime, 'YYYY-MM-DD HH:mm:ss', timezone_selected_iana).utc();
			if (startUtc.isValid()) {
				startdatetime = startUtc.format('YYYY-MM-DD HH:mm:ss');
			}
			if (endUtc.isValid()) {
				enddatetime = endUtc.format('YYYY-MM-DD HH:mm:ss');
			}
		}
		latestGapComparisonEndUtc = enddatetime;
	} else {
		latestGapComparisonEndUtc = enddatetime;
	}

	let shouldRepinWindow = (context === "") || didConsumeDatetimeOverride;
	if (!shouldRepinWindow && lastResolvedDataExplorerWindow && lastResolvedDataExplorerWindow.ts_start && lastResolvedDataExplorerWindow.ts_end) {
		startdatetime = lastResolvedDataExplorerWindow.ts_start;
		enddatetime = lastResolvedDataExplorerWindow.ts_end;
	} else {
		lastResolvedDataExplorerWindow = {
			ts_start: startdatetime,
			ts_end: enddatetime,
			timezone: timezone_selected_iana || 'UTC'
		};
	}

	renderDataExplorerLatestGapNote(latestAvailableUtcText, latestGapComparisonEndUtc);

	queryurl = addQueryParam(queryurl, 'ts_start', startdatetime);
	queryurl = addQueryParam(queryurl, 'ts_end', enddatetime);
	queryurl = addQueryParam(queryurl, 'period_type', resolveDataExplorerPeriodType());

	//queryurl = queryurl + '?ts_start=' + startdatetime + '&ts_end=' + enddatetime;
	//console.log("QUERY TIME window.get_start_date, window.get_end_date, queryurl :", window.get_start_date, window.get_end_date, queryurl)


	queryurl = addQueryParam(queryurl, 'format', 'data');

	if (context == "comparisonStatus") {
		if (modality == "none") {
			// pass
		} else {
			queryurl = addQueryParam(queryurl, 'modality', modality);
		}

	}

	if (context == "graphData" && window.WingmanState.swanbot_dataexplorer_processing_compare_type !== "") {
		queryurl = addQueryParam(queryurl, 'comparisons', window.WingmanState.swanbot_dataexplorer_processing_compare_type);
	} else if (context == "graphData" && modality !== "") {
		queryurl = addQueryParam(queryurl, 'comparisons', modality);

	}


	if (context == "graphData" && window.WingmanState.swanbot_dataexplorer_filter_subgrouping) {
		// clean any leading & or ?
		let clean_subgrouping = window.WingmanState.swanbot_dataexplorer_filter_subgrouping;
		if (clean_subgrouping.startsWith('&') || clean_subgrouping.startsWith('?')) {
			clean_subgrouping = clean_subgrouping.substring(1);
		}
		const separator = queryurl.includes('?') ? '&' : '?';
		queryurl = queryurl + separator + clean_subgrouping;
		window.WingmanState.swanbot_dataexplorer_filter_subgrouping = "";
	}

	if (window.WingmanState.swanbot_dataexplorer_session) {
		queryurl = addQueryParam(queryurl, 'session', window.WingmanState.swanbot_dataexplorer_session);
	}

	if (window.WingmanState.swanbot_key) {
		queryurl = addQueryParam(queryurl, 'key', window.WingmanState.swanbot_key);
	}

	if (customer_name) {
		customer_name = customer_name.value;
		queryurl = addQueryParam(queryurl, 'user_text', customer_name);
		queryurl = addQueryParam(queryurl, 'user_id', customer_name);
	}


	if (query) {
		query = query.replace("&", " and ")
		swanbot_dataexplorer_last_query = query;
		queryurl = addQueryParam(queryurl, 'question', query);
		window.send_dataexplorer_results(query, "user", 0);
	}

	if (timezone_selected) {
		queryurl = addQueryParam(queryurl, 'tz', timezone_selected);
	}

	if (provider_override_select) {
		let provider_override_str = provider_override_select.innerText
		let provider_override_parts = provider_override_str.split(':');
		let provider_override = provider_override_parts[0].trim().replace("*", "");
		queryurl = queryurl + '&profile=' + provider_override;
	}

	//querychartoutput.innerHTML = "<strong></strong>";


	const requestSessionId = window.WingmanState.swanbot_dataexplorer_session || "";
	const loaderVariant = context == "graphData" ? "graph" : "default";
	const isDataOverviewRequest = context === "" && (!requestSessionId || !String(query || "").trim());
	const initialStatus = context === "comparisonStatus"
		? "Loading Comparison Data"
		: (isDataOverviewRequest ? "Generating data overview" : "");
	add_swan_loading("dataexplorer-data-results", loaderVariant, initialStatus); //graph-dataexplorer-details");

	markSwanbotUrlCalled();


	let removeCapacityWait = null;
	const usesRelayChatStream = isSwanbotRelayEnabled() && context === "" && !!query;
	let relayLastStatus = [];
	const requestSwanbotData = function () {
		if (usesRelayChatStream) {
			dataExplorerRelayAbortController = new AbortController();
			return streamDataExplorerChat(queryurl, {
				signal: dataExplorerRelayAbortController.signal,
				onEvent: function (event, data) {
					if (event === 'status' && Array.isArray(data.whatamidoing)) {
						relayLastStatus = renderDataExplorerStatus(data.whatamidoing, relayLastStatus);
					}
				}
			}).finally(function () {
				dataExplorerRelayAbortController = null;
			});
		}

		return axios.get(queryurl, {
			withCredentials: true,
		}).catch(async function (error) {
			if (!isSwanbotCapacityUnavailable(error)) {
				throw error;
			}

			if (removeCapacityWait) {
				removeCapacityWait();
			}
			removeCapacityWait = showSwanbotCapacityWait();
			await new Promise(function (resolve) {
				window.setTimeout(resolve, SWANBOT_CAPACITY_RETRY_DELAY_MS);
			});
			return requestSwanbotData();
		});
	};

	let getdata = requestSwanbotData()

		.then(response => {
			if (removeCapacityWait) {
				removeCapacityWait();
				removeCapacityWait = null;
			}

			if (response.status == 200) {
				const shouldUpdateGraphPayload = context !== "comparisonStatus" && context !== "graphTypes";

                                  if (response.data && response.data.session === null && response.data.output === "Data for this time range is not currently availble. Please try again later.") {
					let e = new Error("Swanbot data not currently available");
					e.code = "ERR_NETWORK";
					throw e;
				}

				handleDataExplorerSessionResponse(response.data && response.data.session, requestSessionId);



				//console.log("response.data", response.data)

				if (shouldUpdateGraphPayload) {
					if ("graphData" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["graphs"] = response.data.graphData;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["graphs"] = [];
					}

					// compare
					let graphdatacompare = "graphData_" + window.WingmanState.swanbot_dataexplorer_processing_compare_type;
					if (graphdatacompare in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"] = response.data[graphdatacompare];
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"] = "";
					}

					if ("filters" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["filters"] = response.data.filters;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["filters"] = [];
					}

					if ("subgraphGroupData" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"] = response.data.subgraphGroupData;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"] = [];
					}

					// compare
					let subgraphdatacompare = "subgraphGroupData_" + window.WingmanState.swanbot_dataexplorer_processing_compare_type;
					if (subgraphdatacompare in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphs_compare"] = response.data[subgraphdatacompare];
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphs_compare"] = "";
					}

					if ("subgraphGroupTitles" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupTitles"] = response.data.subgraphGroupTitles;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupTitles"] = [];
					}

					if ("subgraphGroupDim" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupDimensions"] = response.data.subgraphGroupDim;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupDimensions"] = "";
					}
				}








				if ("output" in response.data) {

					if (response.data.output && response.data.output.trim() !== "") {
						window.send_dataexplorer_results(response.data.output, "swanbot", 0, true);
					}

					if (response.data.output.includes("<filters />")) {
						//console.log("filters in swanbot output")
						let querychartoutput = document.getElementById("graph-dataexplorer-details");
						let queryfilteroutput = document.getElementById("graph-dataexplorer-filters");
						let queryeventoutput = document.getElementById("graph-dataexplorer-events");
						let querytotalsoutput = document.getElementById("graph-dataexplorer-totals");


						//querychartoutput.innerHTML = "<strong></strong>";
						queryfilteroutput.innerHTML = "<strong></strong>";
						queryeventoutput.innerHTML = "<strong></strong>";
						querytotalsoutput.innerHTML = "<strong></strong>";
					}

					if (response.data.output.includes("<agents />")) {
						let queryagentoutput = document.getElementById("graph-dataexplorer-agents");
						if (queryagentoutput) {
							queryagentoutput.innerHTML = "<strong></strong>";
						}

						if (typeof window.make_dataexplorer_agents === "function") {
							window.make_dataexplorer_agents();
						}
					}

				}

				if (context == "graphData") {
					if ("focus" in response.data) {
						window.WingmanState.swanbot_dataexplorer_graphdata["focus"] = response.data.focus;
					} else {
						window.WingmanState.swanbot_dataexplorer_graphdata["focus"] = {};
					}

					if (window.swanbot_dataexplorer_compare_options_requested === true) {
						window.swanbot_dataexplorer_compare_options_stale = true;

						if (window.swanbot_dataexplorer_compare_options_refresh_inflight !== true) {
							window.swanbot_dataexplorer_compare_options_refresh_inflight = true;
							if (typeof window.reset_compare_dataexplorer_options_state === 'function') {
								window.reset_compare_dataexplorer_options_state();
							}
							void load_explorer_swanbot("comparisonStatus", "", "");
						}
					}
				}
				// compare
				if (context == "comparisonStatus") {
					if ("modalities" in response.data) {
						window.set_compare_dataexplorer_options(response.data.modalities)
					}

					if ("status" in response.data) {
						//console.log("comparison loaded", response.data.status)
						if (response.data.status == "Ready") {
							if (window.swanbot_dataexplorer_processing_compare === true) {
								window.compare_dataexplorer_complete(window.WingmanState.swanbot_dataexplorer_processing_compare_type);
							}

						} else {
							if (!("modalities" in response.data) && window.swanbot_dataexplorer_processing_compare === true) {
								console.log("There was an error getting modalities", response)
								window.display_toast("There was an error retrieving comparison options. Please try again! <br/>Status Code: " + response.status + "<br/>Status Text: " + response.statusText + "", mdtoast.ERROR);
								window.compare_dataexplorer_complete("error");
							}

						}

					window.swanbot_dataexplorer_compare_options_refresh_inflight = false;
					}
				}


				if (context == "graphTypes") {
					if ("axis_types" in response.data) {
						//console.log("axis_types in response data", response.data)
						window.WingmanState.swanbot_dataexplorer_graphdata["axis_types"] = response.data.axis_types;
					} else {
						//console.log("NO axis_types in response data", response.data)
						window.WingmanState.swanbot_dataexplorer_graphdata["axis_types"] = {};
					}

					//console.log("window.WingmanState.swanbot_dataexplorer_graphdata", window.WingmanState.swanbot_dataexplorer_graphdata)
				}



			}
			else {
				//window.add_swan_chat("Nothing to see here, no graph data.", 0);
				console.log("swanbot data is not 200: ", response);
			}
		})
		.catch(error => {
			if (removeCapacityWait) {
				removeCapacityWait();
				removeCapacityWait = null;
			}
			console.error("swanbot data error ", error);
			if (error.code == "ERR_NETWORK") {
				console.error("network error requesting swanbot", error.code)
				async function sendMessageSequence() {
					const message = "Hrm... this is odd. We don't seem to have any swanbots available. Please try again in a little while."
					await window.send_dataexplorer_results(message, "swanbot_error", 0);
				}
				sendMessageSequence();
			} else {
				console.error("another error requesting swanbot", error)
			}
			throw error; // Re-throw so callers can catch it properly
		})
		.finally(function () {
			if (context == "graphData") {
				graphDataRequestInFlight = false;
			}

			if (context == "comparisonStatus" && window.swanbot_dataexplorer_processing_compare !== true) {
				window.swanbot_dataexplorer_compare_options_refresh_inflight = false;
			}

			remove_swan_loading();
			if (shouldDisableDataExplorerInputs) {
				swanbot_dataexplorer_input_enabled();
			}
			reset_swanbot_end();

			if (context == "graphData" && graphDataPendingRequestArgs) {
				void replayQueuedGraphDataRequest();
			}
			//window.window.make_swan_graphs();
		});

	trackDataExplorerSwanbotRequest(getdata, { resetKeepAliveCounter: !!query });


	if (query && !usesRelayChatStream) {
		monitorRequestAndPoll(getdata, 2000, 1000);
	}

	return getdata;

}


export async function remove_swan_loading() {
        let swanbot_loader = document.getElementById("swanbot_loading");

        if (swanbot_loader) {
                swanbot_loader.remove();
        } else {
                console.log("no swanbot_loading");
        }
}

function buildSwanLoadingSpinner(loaderVariant = 'default') {
	if (loaderVariant === 'graph') {
		let graphSpinner = document.createElement('div');
		graphSpinner.setAttribute('class', 'swanbot_loading_badge swanbot_loading_graph');
		graphSpinner.setAttribute('id', 'swanbot_loading_spinner');
		graphSpinner.setAttribute('aria-hidden', 'true');
		graphSpinner.innerHTML = `
			<svg class="swanbot_loading_graph_svg" viewBox="0 0 44 24" focusable="false" aria-hidden="true">
				<path class="swanbot_loading_graph_axis" d="M2 2 V21 H42" />
				<path class="swanbot_loading_graph_track" d="M5 17 L13 13 L20 15 L29 7 L38 10" pathLength="100" />
				<path class="swanbot_loading_graph_line" d="M5 17 L13 13 L20 15 L29 7 L38 10" pathLength="100" />
				<circle class="swanbot_loading_graph_dot" cx="5" cy="17" r="2.2">
					<animate attributeName="cx" values="5;13;20;29;38" dur="1.45s" repeatCount="indefinite" calcMode="spline" keySplines="0.33 0 0.67 1;0.33 0 0.67 1;0.33 0 0.67 1;0.33 0 0.67 1" />
					<animate attributeName="cy" values="17;13;15;7;10" dur="1.45s" repeatCount="indefinite" calcMode="spline" keySplines="0.33 0 0.67 1;0.33 0 0.67 1;0.33 0 0.67 1;0.33 0 0.67 1" />
				</circle>
			</svg>`;

		return graphSpinner;
	}

	let defaultSpinner = document.createElement('span');
	defaultSpinner.setAttribute('class', 'swanbot_loading_badge swanbot_loading_thinking');
	defaultSpinner.setAttribute('id', 'swanbot_loading_spinner');
	defaultSpinner.setAttribute('aria-hidden', 'true');
	defaultSpinner.innerHTML = `
		<span class="swanbot_loading_activity" aria-hidden="true">
			<span></span><span></span><span></span><span></span>
		</span>`;
	return defaultSpinner;
}

export async function add_swan_loading(swanbot_container_id, loaderVariant = 'default', initialStatus = '') {
        let container = document.getElementById(swanbot_container_id);

        if (!container) {
                console.error("Error: swanbot_chat_container element not found!");
                return;
        }

        let swanbot_loader = document.getElementById("swanbot_loading");

        if (swanbot_loader) {
                console.log("swanbot_loader already running");
        } else {
                swanbot_loader = document.createElement('div');
                swanbot_loader.setAttribute('class', 'swanbot_loading');
                swanbot_loader.setAttribute("id", "swanbot_loading");

                let swanbot_loader_status = document.createElement('span');
                swanbot_loader_status.setAttribute('class', 'swanbot_loading_status');
                swanbot_loader_status.setAttribute("id", "swanbot_loading_status");
			swanbot_loader_status.setAttribute('role', 'status');
			swanbot_loader_status.setAttribute('aria-live', 'polite');
			swanbot_loader_status.setAttribute('aria-atomic', 'true');
                swanbot_loader.appendChild(swanbot_loader_status);

                container.appendChild(swanbot_loader);
        }

	let existingSpinner = document.getElementById('swanbot_loading_spinner');
	let desiredSpinner = buildSwanLoadingSpinner(loaderVariant);
	let swanbot_loader_status = document.getElementById('swanbot_loading_status');

	if (existingSpinner) {
		existingSpinner.replaceWith(desiredSpinner);
	} else if (swanbot_loader_status) {
		swanbot_loader.insertBefore(desiredSpinner, swanbot_loader_status);
	} else {
		swanbot_loader.appendChild(desiredSpinner);
	}

	if (!swanbot_loader_status) {
		swanbot_loader_status = document.createElement('span');
		swanbot_loader_status.setAttribute('class', 'swanbot_loading_status');
		swanbot_loader_status.setAttribute('id', 'swanbot_loading_status');
		swanbot_loader_status.setAttribute('role', 'status');
		swanbot_loader_status.setAttribute('aria-live', 'polite');
		swanbot_loader_status.setAttribute('aria-atomic', 'true');
		swanbot_loader.appendChild(swanbot_loader_status);
	}

	swanbot_loader_status.textContent = initialStatus || (loaderVariant === 'graph' ? 'Generating Graph' : '');

        setTimeout(function () {
                let swanbot_loader = document.getElementById("swanbot_loading");

                if (swanbot_loader) {
                        swanbot_loader.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                } else {
                        console.log("cannot scroll to loader");
                }
        }, 100);
}